/*
 * Mobile - Side Cart - Estimated Delivery Date  --  variant: Shipping Timeline Badge
 * Moonshot experiment id: PE-4013f747-c0fb-4db9-9337-56ed44ad9ea3   status in Moonshot on 2026-08-27: RUNNING   started: 2026-08-17
 * Audience: MOBILE   Target: side_cart   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_sc_m_delivery_date
 */
MGExp.run('sc_m_delivery_date', { name: "Mobile - Side Cart - Estimated Delivery Date / Shipping Timeline Badge", platform: 'mobile', target: 'side_cart' }, function () {
  !(function () {
    let e = [],
      t = [
        "button.bag-checkout",
        ".money.pre-money[data-cart-total]",
        ".bag-total",
      ];
    function n(e, t) {
      const n = new Date(e.getTime());
      let r = 0;
      for (; r < t;) {
        n.setDate(n.getDate() + 1);
        const e = n.getDay();
        0 !== e && 6 !== e && r++;
      }
      return n;
    }
    function r(e, t) {
      const n = new Date(e.getTime());
      return (n.setDate(n.getDate() + t), n);
    }
    function i(e) {
      return (
        ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][e.getDay()] +
        ", " +
        [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ][e.getMonth()] +
        " " +
        e.getDate()
      );
    }
    function a(e) {
      if (!e) return 0;
      const t = e.replace(/[^0-9.]/g, "");
      return parseFloat(t) || 0;
    }
    function o(e) {
      const t = (
          e ||
          document.querySelector("#mini-cart-modal") ||
          document
        ).querySelectorAll("#mini-cart-items-list > li, .bag-line-item"),
        n = new Set();
      let r = null,
        i = 0;
      const a = new Date();
      return (
        a.setHours(0, 0, 0, 0),
        t.forEach((e) => {
          const t = e.closest("li") || e;
          if (n.has(t)) return;
          n.add(t);
          if (!t.querySelector(".preorder")) return;
          const o = t.querySelectorAll("p");
          let s = null;
          (o.forEach((e) => {
            if (s) return;
            const t = e.textContent || "";
            if (/ship\s*date\s*:/i.test(t)) {
              const e = (function (e) {
                if (!e) return null;
                const t = String(e).match(
                  /(\d{1,2})\s*\/\s*(\d{1,2})\s*\/\s*(\d{4})/,
                );
                if (!t) return null;
                const n = parseInt(t[1], 10) - 1,
                  r = parseInt(t[2], 10),
                  i = parseInt(t[3], 10);
                if (n < 0 || n > 11 || r < 1 || r > 31) return null;
                const a = new Date(i, n, r);
                return isNaN(a.getTime()) ? null : a;
              })(t);
              e && e.getTime() >= a.getTime() && (s = e);
            }
          }),
            s && (i++, (!r || s.getTime() > r.getTime()) && (r = s)));
        }),
        { hasPreorder: i > 0, latestShipDate: r, preorderItemCount: i }
      );
    }
    function s(e, t) {
      const a = o(t);
      if (a.hasPreorder)
        return {
          tierLabel: "Pre-Order · Fully Insured",
          dateRange: i(a.latestShipDate),
          isPreorder: !0,
          deliveryMode: "regular",
        };
      let s, l, c, d;
      if (e >= 5e3)
        ((s = 1),
          (l = 1),
          (c = "business"),
          (d = "Overnight Shipping · Fully Insured"));
      else if (e >= 1e3) {
        const e = (function (e) {
          const t = (
              e ||
              document.querySelector("#mini-cart-modal") ||
              document
            ).querySelectorAll('a[href*="/products/"], a[href*="/product/"]'),
            n = new Set(),
            r =
              /(handbag|hand-bag|\bbags?\b|tote|purse|clutch|crossbody|shoulder-bag|backpack|satchel|hobo|wallet)/i,
            i =
              /(watch|jewel(?:le)?ry|\bring\b|necklace|bracelet|earring|pendant|brooch|\bchain\b|cufflink|tiara|bangle)/i;
          return (
            t.forEach((e) => {
              const t = (
                (e.getAttribute("href") || "") +
                " " +
                (e.textContent || "")
              ).toLowerCase();
              r.test(t) ? n.add("handbag") : i.test(t) && n.add("jewelry");
            }),
            n
          );
        })(t);
        e.has("handbag")
          ? ((s = 2),
            (l = 5),
            (c = "regular"),
            (d = "Free Shipping · Fully Insured"))
          : ((s = 2),
            (l = 2),
            (c = "business"),
            (d = "Expedited Shipping · Fully Insured"));
      } else {
        ((s = 1),
          (l = 5),
          (c = "regular"),
          (d = "Standard Shipping · Fully Insured"));
        const e = (function (e) {
          const t = e || document.querySelector("#mini-cart-modal") || document,
            n = t.querySelectorAll("#mini-cart-items-list > li");
          return n.length
            ? n.length
            : t.querySelectorAll(".bag-line-item").length;
        })(t);
        e > 1 && (s = l);
      }
      const u = n(
          (function () {
            const e = new Date(),
              t = e.getDay();
            return (
              0 === t && e.setDate(e.getDate() + 1),
              6 === t && e.setDate(e.getDate() + 2),
              e
            );
          })(),
          1,
        ),
        m = "business" === c ? n : r,
        g = m(u, s),
        p = m(u, l);
      return {
        tierLabel: d,
        dateRange: s === l ? i(g) : i(g) + " – " + i(p),
        isPreorder: !1,
        deliveryMode: c,
      };
    }
    !(async function (n, r, i, a, o) {
      let s = {
        multi_target_selectors: e,
        page_identifier_selector: "#mini-cart-modal",
        exclude_from_timeout: t,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(n, r, i, a, o, s);
    })(
      ["button.bag-checkout", ".money.pre-money[data-cart-total]", ".bag-total"],
      ".msai-delivery-estimate-applied",
      function (e, t) {
        const [n, r, i] = t,
          o = n.closest("form"),
          l = document.querySelector("#mini-cart-modal") || document,
          c = document.createElement("div"),
          d = document.createElement("div");
        d.className = "msai-delivery-estimate";
        const u = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        (u.setAttribute("xmlns", "http://www.w3.org/2000/svg"),
          u.setAttribute("width", "16"),
          u.setAttribute("height", "16"),
          u.setAttribute("viewBox", "0 0 24 24"),
          u.setAttribute("fill", "#000"),
          u.classList.add("msai-delivery-icon"));
        const m = document.createElementNS("http://www.w3.org/2000/svg", "path");
        (m.setAttribute(
          "d",
          "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z",
        ),
          u.appendChild(m),
          d.appendChild(u));
        const g = document.createElement("span");
        ((g.className = "msai-delivery-text"), d.appendChild(g));
        const p = document.createElement("div");
        ((p.className = "msai-delivery-tier"),
          c.appendChild(d),
          c.appendChild(p));
        const h = s(a(r.textContent), l);
        ((g.textContent =
          (h.isPreorder ? "Ships on " : "Est. Delivery: ") + h.dateRange),
          (p.textContent = h.tierLabel),
          o.insertAdjacentElement("beforebegin", c));
        const y = document.querySelector("#mini-cart-modal") || i,
          f = new MutationObserver(() => {
            const e = document.querySelector(".msai-delivery-estimate-applied");
            if (!e || !e.isConnected) return void f.disconnect();
            const t = document.querySelector(".money.pre-money[data-cart-total]");
            if (!t) return;
            const n = e.querySelector(".msai-delivery-text"),
              r = e.querySelector(".msai-delivery-tier");
            if (!n || !r) return;
            const i = document.querySelector("#mini-cart-modal") || document,
              o = s(a(t.textContent), i),
              l = (o.isPreorder ? "Ships on " : "Est. Delivery: ") + o.dateRange;
            (n.textContent !== l && (n.textContent = l),
              r.textContent !== o.tierLabel && (r.textContent = o.tierLabel));
          });
        (f.observe(y, { childList: !0, subtree: !0, characterData: !0 }),
          c.classList.add("msai-delivery-estimate-applied"));
      },
      ".msai-delivery-estimate{display:flex;align-items:center;justify-content:center;gap:6px;padding:4px 20px 12px;font-family:Raleway,sans-serif;font-size:13px;font-weight:500;color:#000;text-align:center}.msai-delivery-icon{display:inline-block;vertical-align:middle;flex-shrink:0}.msai-delivery-tier{font-size:11px;color:#666;display:block;text-align:center;padding:0 20px 16px;font-family:Raleway,sans-serif}",
    );
  })();
});
